import PatrimonioListagem from '@/views/pages/patrimonio/listagem/PatrimonioListagem'
import PatrimonioEdicao from '@/views/pages/patrimonio/edicao/PatrimonioEdicao'
import DadosDeEntradaEdicao from '@/views/pages/patrimonio/edicao/dados-de-entrada/DadosDeEntradaEdicao'
import ListagemDocumentosPatrimonio from '@/views/pages/patrimonio/edicao/documentos/ListagemDocumentosPatrimonio'
import TipoNovo from '@/views/pages/patrimonio/edicao/tipo/TipoNovo'
import TipoEdicao from '@/views/pages/patrimonio/edicao/tipo/TipoEdicao'
import MenuDetalhe from '@/views/pages/patrimonio/detalhe/MenuDetalhe'
import ModalMovimentacao from '@/views/pages/patrimonio/detalhe/movimentacao/ModalMovimentacao'
import PatrimonioDetalhe from '@/views/pages/patrimonio/detalhe/dadosGerais/PatrimonioDetalhe'
import NovaMovimentacao from '@/views/pages/patrimonio/detalhe/movimentacao/NovaMovimentacao'
import ModalMovimentacaoBaixa from '@/views/pages/patrimonio/detalhe/movimentacao/ModalMovimentacaoBaixa.vue'
import NovaReavaliacao from '@/views/pages/patrimonio/detalhe/reavaliacao/NovaReavaliacao.vue'
import ModalReavaliacao from '@/views/pages/patrimonio/detalhe/reavaliacao/ModalReavaliacao.vue'
import ModalReavaliacaoDetalhes from '@/views/pages/patrimonio/detalhe/reavaliacao/ModalReavaliacaoDetalhes.vue'
import NovoAjuste from '@/views/pages/patrimonio/detalhe/ajuste/NovoAjuste.vue'
import ModalNovoAjuste from '@/views/pages/patrimonio/detalhe/ajuste/ModalNovoAjuste.vue'
import ModalAjusteDetalhes from '@/views/pages/patrimonio/detalhe/ajuste/ModalAjusteDetalhes.vue'

export default [
    {
        path: '/patrimonios',
        name: 'TodosPatrimonios',
        component: PatrimonioListagem,
        meta: {
            menu: {
                title: 'Registros',
                icon: 'view_list',
            },
            page: {
                title: 'Registros',
                subtitle:
                    'Lista geral dos registros de entradas no seu patrimônio',
            },
            requiresAuth: true,
            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta'],
        },
    },
    {
        path: '/patrimonio/novo',
        name: 'PatrimonioNovo',
        component: PatrimonioEdicao,
        redirect: { name: 'TipoNovo' },
        children: [
            {
                path: 'tipo',
                name: 'TipoNovo',
                component: TipoNovo,
                meta: {
                    page: {
                        title: 'Adicionar Nova Entrada',
                        showAutoSave: true,
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta'],
                },
            },
        ],
    },
    {
        path: '/patrimonio/:id',
        name: 'PatrimonioEdicao',
        component: PatrimonioEdicao,
        children: [
            {
                path: 'tipo/edicao',
                name: 'TipoEdicao',
                component: TipoEdicao,
                meta: {
                    page: {
                        title: 'Editar Entrada',
                        showAutoSave: true,
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta'],
                },
            },
            {
                path: 'dados-de-entrada/edicao',
                name: 'DadosDeEntradaEdicao',
                component: DadosDeEntradaEdicao,
                meta: {
                    page: {
                        title: 'Editar Entrada',
                        showAutoSave: true,
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta'],
                },
            },
            {
                path: 'documentos/edicao',
                name: 'DocumentosEdicao',
                component: ListagemDocumentosPatrimonio,
                meta: {
                    page: {
                        title: 'Editar Entrada',
                        showAutoSave: true,
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta'],
                },
            },
        ],
    },
    {
        path: '/apresentacao/:id',
        name: 'MenuDetalhe',
        component: MenuDetalhe,
        children: [
            {
                path: 'movimentacao',
                name: 'NovaMovimentacao',
                component: NovaMovimentacao,
                props: { tabs: 1 },
                meta: {
                    page: {
                        title: 'Movimentar Patrimônio',
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal'],
                },
                children: [
                    {
                        path: 'editar/:movimentacaoId',
                        name: 'ModalMovimentacao',
                        component: ModalMovimentacao,
                        meta: {
                            page: {
                                title: 'Dados Individuais do Patrimônio',
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal'],
                        },
                    },
                    {
                        path: 'baixa/editar/:movimentacaoId',
                        name: 'ModalMovimentacaoBaixa',
                        component: ModalMovimentacaoBaixa,
                        meta: {
                            page: {
                                title: 'Dados Individuais do Patrimônio',
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal'],
                        },
                    },
                ],
            },
            {
                path: 'reavaliacao',
                name: 'NovaReavaliacao',
                component: NovaReavaliacao,
                props: { tabs: 2 },
                meta: {
                    page: {
                        title: 'Reavaliar Patrimônio',
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal'],
                },
                children: [
                    {
                        path: 'novo',
                        name: 'ModalReavaliacao',
                        component: ModalReavaliacao,
                        meta: {
                            page: {
                                title: 'Reavaliar Patrimônio',
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal'],
                        },
                    },
                    {
                        path: ':reavaliacaoId/detalhes',
                        name: 'ModalReavaliacaoDetalhes',
                        component: ModalReavaliacaoDetalhes,
                        meta: {
                            page: {
                                title: 'Reavaliar Patrimônio',
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal'],
                        },
                    },
                ],
            },
            {
                path: 'ajuste',
                name: 'NovoAjuste',
                component: NovoAjuste,
                props: { tabs: 3 },
                meta: {
                    page: {
                        title: 'Ajustar Patrimônio',
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal'],
                },
                children: [
                    {
                        path: 'novo',
                        name: 'ModalNovoAjuste',
                        component: ModalNovoAjuste,
                        meta: {
                            page: {
                                title: 'Ajustar Patrimônio',
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal'],
                        },
                    },
                    {
                        path: ':ajusteId/detalhes',
                        name: 'ModalAjusteDetalhes',
                        component: ModalAjusteDetalhes,
                        meta: {
                            page: {
                                title: 'Ajustar Patrimônio',
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal'],
                        },
                    },
                 ],
            },
            {
                path: 'ficha',
                name: 'FichaPatrimonio',
                component: PatrimonioDetalhe,
                props: { tabs: 0 },
                meta: {
                    page: {
                        title: 'Dados Individuais do Patrimônio',
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal'],
                },
            },
        ],
    },
]
